var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.items,
      "single-line": "",
      solo: "",
      "hide-details": "",
      label: _vm.label,
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      loading: _vm.coIsLoading,
      disabled: _vm.disabled,
      "menu-props": "closeOnContentClick",
      multiple: _vm.multiple,
      clearable: _vm.clearable,
      "search-input": _vm.dtSearch,
      "hide-no-data": ""
    },
    on: {
      change: _vm.onChange,
      "update:searchInput": function($event) {
        _vm.dtSearch = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function(data) {
          return [
            _vm.multiple === true && data.index === _vm.vModel.length - 1
              ? _c(
                  "v-chip",
                  { attrs: { color: "secondary", "text-color": "whitePure" } },
                  [
                    _c("span", { staticStyle: { width: "auto" } }, [
                      _vm._v(_vm._s(_vm.truncate(data.item.name)) + " ")
                    ]),
                    _vm._v("   \n      "),
                    _c(
                      "span",
                      { staticStyle: { width: "auto", color: "#2E038C" } },
                      [_vm._v(_vm._s(_vm.othersText()))]
                    )
                  ]
                )
              : _vm.multiple === false
              ? _c(
                  "v-chip",
                  { attrs: { color: "secondary", "text-color": "whitePure" } },
                  [
                    _c("span", { staticStyle: { width: "auto" } }, [
                      _vm._v(_vm._s(_vm.truncate(data.item.name)))
                    ])
                  ]
                )
              : _vm._e()
          ]
        }
      }
    ]),
    model: {
      value: _vm.vModel,
      callback: function($$v) {
        _vm.vModel = $$v
      },
      expression: "vModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1eb3c7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1eb3c7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-maintenances/components/MRAutocompleteSelector/template.html
// module id = null
// module chunks = 